import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './AppModal.css';

function AppModal({ open, title, message, onClose, actions = [] }) {
  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const handleEscape = (event) => {
      if (event.key === 'Escape' && onClose) {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEscape);

    return () => {
      document.body.style.overflow = originalOverflow;
      window.removeEventListener('keydown', handleEscape);
    };
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  const modalActions = actions.length
    ? actions
    : [{ label: 'OK', onClick: onClose, variant: 'primary' }];

  return createPortal(
    <div className="app-modal-overlay" role="dialog" aria-modal="true" aria-label={title}>
      <div className="app-modal-card">
        {title && <h3>{title}</h3>}
        {message && <p>{message}</p>}

        <div className="app-modal-actions">
          {modalActions.map((action, index) => (
            <button
              key={`${action.label}-${index}`}
              type="button"
              className={`btn ${action.variant === 'secondary' ? 'btn-secondary' : action.variant === 'danger' ? 'btn-danger' : ''}`.trim()}
              onClick={action.onClick}
              disabled={action.disabled}
            >
              {action.label}
            </button>
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
}

export default AppModal;
